<template>
  <v-card tile >
    <loader v-if="$wait.is('getUposlenikDetails')" class="pt-12"></loader>
    <v-card-text
    class="pa-12 pt-0"
      v-else-if="selectedStraniAutor"
    >
      <v-row no-gutters class="pb-2 pt-5">
        <v-col cols="12">
          <h3 style="color: rgb(8, 71, 118)">Ime i prezime</h3> </v-col
        ><v-col>
          <h4 style="color: black" class="pt-2">
            {{ selectedStraniAutor.ime }} {{ selectedStraniAutor.prezime }}
          </h4></v-col
        ></v-row
      >
      <v-divider v-if="selectedStraniAutor.akad_stupanj_id"></v-divider>
      <v-row
        v-if="selectedStraniAutor.akad_stupanj_id"
        no-gutters
        class="pb-2 pt-5"
      >
        <v-col cols="12">
          <h3 style="color: rgb(8, 71, 118)">Akademski stupanj</h3> </v-col
        ><v-col>
          <h4 style="color: black" class="pt-2">
            {{ getAkademskiStupanj }}
          </h4></v-col
        ></v-row
      >
      <v-divider v-if="selectedStraniAutor.zvanje_id"></v-divider>
      <v-row v-if="selectedStraniAutor.zvanje_id" no-gutters class="pb-2 pt-5">
        <v-col cols="12"> <h3 style="color: rgb(8, 71, 118)">Zvanje</h3> </v-col
        ><v-col>
          <h4 style="color: black" class="pt-2">
            {{ getZvanje }}
          </h4></v-col
        ></v-row
      >

      <v-divider v-if="selectedStraniAutor.organizacija"></v-divider>
      <v-row
        v-if="selectedStraniAutor.organizacija"
        no-gutters
        class="pb-2 pt-5"
      >
        <v-col cols="12">
          <h3 style="color: rgb(8, 71, 118)">Organizacija</h3> </v-col
        ><v-col>
          <h4 style="color: black" class="pt-2">
            {{ selectedStraniAutor.organizacija }}
          </h4></v-col
        ></v-row
      >
      <v-divider v-if="selectedStraniAutor.sifra"></v-divider>
      <v-row v-if="selectedStraniAutor.sifra" no-gutters class="pb-2 pt-5">
        <v-col cols="12"> <h3 style="color: rgb(8, 71, 118)">Šifra</h3> </v-col
        ><v-col>
          <h4 style="color: black" class="pt-2">
            {{ selectedStraniAutor.sifra }}
          </h4></v-col
        ></v-row
      >
      <v-divider v-if="radoviAutora.length"></v-divider>

      <v-row v-if="radoviAutora.length > 0" no-gutters class="pb-2 pt-5">
        <v-col cols="12">
          <h3 style="color: rgb(8, 71, 118)" class="pb-2">
            Znanstveni radovi
          </h3> </v-col
        ><v-col>
          <v-card
            style="cursor: pointer"
            elevation="1"
            class="pa-0 mb-3"
            color="accent"
            v-for="item in radoviAutora"
            :key="item.id"
          >
            <!-- new -->
            <v-card-title
              @click="goToRad(item)"
              v-if="item.verificiran == '1' || hasAdminRights"
              class="d-flex justify-center align-center pa-0 pr-3 pl-3"
            >
              <h5>
                {{ item.naslov }}
              </h5>
              <v-spacer></v-spacer>
              <v-btn fab icon>
                <v-icon color="primary">mdi-chevron-right</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
        </v-col></v-row
      >
    </v-card-text>

    <v-dialog fullscreen v-model="editRadDialog">
      <v-toolbar color="rgb(8, 71, 118)" flat v-if="selectedRad">
        <v-icon
          :disabled="$wait.is('verifikacija')"
          @click="closeDetails"
          class="mr-2 ml-0"
          color="white"
          left
          >mdi-close</v-icon
        >
        <h4 v-if="$vuetify.breakpoint.mdAndUp" style="color: white">
          {{ selectedRad.naslov }}
        </h4>
      </v-toolbar>
      <detalji-rada 
    class="pa-12 pt-0"></detalji-rada>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { waitFor } from "vue-wait";

export default {
  // metaInfo: {
  //     title: 'Detalji o stranom autoru  - Registar radova'
  //   },
  props: ["selectedStraniAutor"],
  computed: {
    ...mapGetters([
      "getAkademskiStupnjevi",
      "getZvanja",
      "getUser",
      "hasAdminRights",
    ]),
    getZvanje() {
      let data = null;
      this.getZvanja.forEach((zvanje) => {
        if (zvanje.id == this.selectedStraniAutor.zvanje_id) {
          data = zvanje.naziv;
        }
      });
      return data;
    },
    getAkademskiStupanj() {
      let data = null;
      this.getAkademskiStupnjevi.forEach((as) => {
        if (as.id == this.selectedStraniAutor.akad_stupanj_id) {
          data = as.naziv;
        }
      });
      return data;
    },
    // new
    radoviAutora() {
      if (
        this.selectedStraniAutor.znanstveni_radovi.length &&
        this.selectedStraniAutor.znanstveni_radovi
      ) {
        const unique = [...new Set(this.selectedStraniAutor.znanstveni_radovi)]  
        return unique;
      } else {
        return [];
      }
    },
  },
  methods: {
    goToRad(item) {
      this.selectedRad = item;
      waitFor("getRadDetails", async function () {
        await this.$store.dispatch("fetchRad", item.id);
      }).apply(this);

      this.editRadDialog = true;
    },
    async closeDetails() {
      this.editRadDialog = false;
    },
  },
  data: () => ({
    selectedRad: {},
    editRadDialog: false,
  }),
};
</script>



